module.exports = __webpack_public_path__ + "static/img/Ring-of-day-red.c45cd4cd.svg";